
<template>
    <div>
        <mars-view class="refund-wrapper"><top-bar title="退款" text-color="#000" :bg-color="topBar.bgColor"></top-bar><mars-view class="bg"></mars-view><steps :cur-step="curStep"></steps><step-one v-if="curStep === 1" :order-id="orderId" @submitSucc="submitSucc"></step-one><step-other v-else :submit-data="detail" :order-id="orderId" :status="status"></step-other></mars-view>
    </div>
</template>

<script>
import Topbar from "../../components/common/topbar.vue";
import steps from "../../components/refund/steps.vue";
import stepOne from "../../components/refund/stepOne.vue";
import stepOther from "../../components/refund/stepOther.vue";
import { request } from '../../static/utils/request';
import { reqPathTo } from '../../static/utils/env.js';
import log from '../../static/utils/ubcLog';
export default {
  components: {
    'top-bar': Topbar,
    steps,
    'step-one': stepOne,
    'step-other': stepOther
  },
  data() {
    return {
      orderId: '',
      // 订单id
      curStep: 1,
      // 当前步骤
      detail: {},
      status: '',
      topBar: {
        bgColor: 'transparent'
      }
    };
  },
  watch: {
    'detail.status': {
      handler(val) {
        // status

        this.status = {
          30: 2,
          // 审核中
          40: 3,
          // 退款中
          50: 3,
          // 退款中
          60: 4,
          // 退款成功
          35: 5,
          // 退款失败
          70: 5,
          // 退款失败
          36: 6 // 取消退款
        }[val || ''] || 1;
        this.curStep = this.status <= 3 ? this.status : 4;
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 退款提交成功
     * @param {Object} data 提交的数据
     */

    submitSucc() {
      this.getConsultDetail();
    },
    /**
     * 获取咨询订单详情
     */

    getConsultDetail() {
      request({
        url: reqPathTo('detail', {}, '', 'falv/order'),
        data: {
          order_id: this.orderId
        }
      }).then(res => {
        res = res && res.data || {};
        this.detail = res.data || {};
        this.hideLoading();
      });
    },
    showLoading() {
      this.$api.showLoading({
        title: '加载中...',
        mask: true
      });
    },
    hideLoading() {
      this.$api.hideLoading();
    },
    onPageScroll(e) {
      // 当滑动一定距离时 topbar 背景颜色变化
      this.topBar = {
        bgColor: e.scrollTop >= 22 ? '#fff' : 'transparent'
      };
    }
  },
  created() {
    (function (data) {
      log.addKey && log.addKey({
        page: 'relund'
      });
      // 退款页面曝光打点
      log.send && log.send({
        serverId: 17167,
        action: 'show',
        area: 're-show'
      });
      // 订单id, 必传
      this.orderId = data.order_id || '';
      this.showLoading();
      this.getConsultDetail();
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.refund-wrapper {
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.refund-wrapper .bg {
  height: 2rem;
  width: 100%;
  position: absolute;
  top: 0;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/header-bg.png') no-repeat center top / cover;
}
.refund-wrapper .box {
  margin: 0 0.08rem;
  background: #fff;
  border: 0.5px solid #edf0fc;
  border-radius: 0.12rem;
  padding: 0.16rem 0.13rem;
  position: relative;
  z-index: 1;
}
.refund-wrapper .box:not(:first-child) {
  margin-top: 0.08rem;
}
.refund-wrapper .box.explain {
  padding-bottom: 0.11rem;
}
.refund-wrapper .box .title {
  font-family: PingFangSC-Medium;
  font-size: 0.17rem;
  color: #1e1f24;
  letter-spacing: 0;
  line-height: 1;
  font-weight: 500;
  margin-bottom: 0.14rem;
}
.refund-wrapper .box .title .tips {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #848691;
  line-height: 1;
  font-weight: 400;
  margin-left: 0.08rem;
}
.refund-wrapper .box .tips {
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #848691;
  margin-top: 0.07rem;
  line-height: 0.24rem;
  font-weight: 400;
}

</style>
